export let noItemsSelected = "KHo3Z";
export let oneItemSelected = "Q$pJDd";
export let someItemsSelected = "Bs9y0b";
export default {noItemsSelected,oneItemSelected,someItemsSelected};